
import { CONFIG } from "../../config";
import { axios,axiosALiv } from "../../interceptors";

const handleError = err => {
  return Promise.reject(err.response)
};

const fetchUserFacePhotos = async (user_id) => {
  try {
    const res = await axios.get(`${CONFIG.API_URL}/user-face-imgs/?user_id=${user_id}`);
    return res.data;
  } catch (err) {
    return handleError(err);
  }
};

const saveUserFaceImage = async (data, user_id) => {

  try {
    const res = await axios({
      url: `${CONFIG.API_URL}/save-user-face-img`,
      method: "POST",
      data: { data, user_id }
    });
    return res.data;
  } catch (error) {
    return (handleError(error));
  }
};

const deleteUserFacePhoto = async (data) => {

  try {
    const res = await axios({
      url: `${CONFIG.API_URL}/delete-user-face-img`,
      method: "POST",
      data
    });
    return res.data;
  } catch (error) {
    return (handleError(error));
  }
};

const fetchAllFaces = async (user_id) => {

  try {
    const res = await axios.get(`${CONFIG.API_URL}/fetch-all-faces/?user_id=${user_id}`);
    return res.data;
  } catch (error) {
    return (handleError(error));
  }
};

const markMyAttendance = async (data) => {
  try {
    const res = await axiosALiv.post(`${CONFIG.ALIV_URL}/FaceRecognitionAPI/getScanLogs`, data);
    return res.data;
  } catch (error) {
    return (handleError(error));
  }
};

export const _rest = {
  fetchUserFacePhotos, saveUserFaceImage, deleteUserFacePhoto, fetchAllFaces, markMyAttendance
};
